
const disclaimer =
    "Please note we will not touch your personal or work data. While clean-up takes place in the background, feel free to use assistance.";
export const failureMsg = "chatBot.nexthinkIntegration.failureMsg";
export const nexthinkRemoteActions: Record<
    string,
    {
        actionId: string;
        primaryBtn: string;
        secondaryBtn: string;
        successMsg: string;
        taskProgressMsg: string;
        failureMsg: string;
        disclaimer: string;
        acknowledgeQuery: string;
    }
> = {
    "disk-cleanup": {
        actionId: "#disk_cleanup_deep",
        primaryBtn: "chatBot.nexthinkIntegration.diskClean.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.diskClean.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.diskClean.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.diskClean.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.diskClean.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.diskClean.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.diskClean.acknowledgeQuery",
    },
    "chrome-cache": {
        actionId: "#clear_chrome_cache",
        primaryBtn: "chatBot.nexthinkIntegration.chromeCache.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.chromeCache.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.chromeCache.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.chromeCache.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.chromeCache.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.chromeCache.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.chromeCache.acknowledgeQuery",
    },
    "edge-cache": {
        actionId: "#clear_microsoft_edge_settings_gsd",
        primaryBtn: "chatBot.nexthinkIntegration.edgeCache.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.edgeCache.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.edgeCache.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.edgeCache.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.edgeCache.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.edgeCache.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.edgeCache.acknowledgeQuery",
    },
    "repair-O365-apps": {
        actionId: "#repair_empower_addin",
        primaryBtn: "chatBot.nexthinkIntegration.empowerApp.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.empowerApp.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.empowerApp.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.empowerApp.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.empowerApp.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.empowerApp.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.empowerApp.acknowledgeQuery",
    },
    "clear-teams-cache": {
        actionId: "#clear_microsoft_teams_work_or_school_cache_no_campaign",
        primaryBtn: "chatBot.nexthinkIntegration.teamsCache.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.teamsCache.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.teamsCache.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.teamsCache.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.teamsCache.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.teamsCache.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.teamsCache.acknowledgeQuery",
    },
    "reinstall-teams": {
        actionId: "#repair_teams_application_with_live_notification",
        primaryBtn: "chatBot.nexthinkIntegration.teamsReinstall.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.teamsReinstall.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.teamsReinstall.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.teamsReinstall.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.teamsReinstall.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.teamsReinstall.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.teamsReinstall.acknowledgeQuery",
    },
    "Outlook-reset": {
        actionId: "repair_outlook_ost_problem_windows",
        primaryBtn: "chatBot.nexthinkIntegration.outlookOst.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.outlookOst.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.outlookOst.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.outlookOst.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.outlookOst.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.outlookOst.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.outlookOst.acknowledgeQuery",
    },
    "O365-issues": {
        actionId: "repair_office_365_windows",
        primaryBtn: "chatBot.nexthinkIntegration.repairOfficeApps.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.repairOfficeApps.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.repairOfficeApps.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.repairOfficeApps.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.repairOfficeApps.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.repairOfficeApps.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.repairOfficeApps.acknowledgeQuery",
    },
    "Intune-sync": {
        actionId: "#trigger_intune_sync",
        primaryBtn: "chatBot.nexthinkIntegration.intuneSync.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.intuneSync.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.intuneSync.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.intuneSync.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.intuneSync.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.intuneSync.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.intuneSync.acknowledgeQuery",
    },
    "Repair-Msteams": {
        actionId: "#repair_microsoft_teams_addin",
        primaryBtn: "chatBot.nexthinkIntegration.teamsAddin.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.teamsAddin.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.teamsAddin.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.teamsAddin.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.teamsAddin.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.teamsAddin.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.teamsAddin.acknowledgeQuery",
    },
    "Windows-update": {
        actionId: "invoke_windows_update_windows",
        primaryBtn: "chatBot.nexthinkIntegration.windowsUpdate.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.windowsUpdate.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.windowsUpdate.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.windowsUpdate.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.windowsUpdate.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.windowsUpdate.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.windowsUpdate.acknowledgeQuery",
    },
    "timezone": {
        actionId: "#set_timezone_auto_update",
        primaryBtn: "chatBot.nexthinkIntegration.timezone.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.timezone.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.timezone.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.timezone.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.timezone.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.timezone.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.timezone.acknowledgeQuery",
    },
    "autocomplete": {
        actionId: "clear_outlook_autocomplete_cache_windows",
        primaryBtn: "chatBot.nexthinkIntegration.outlookAutoComplete.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.outlookAutoComplete.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.outlookAutoComplete.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.outlookAutoComplete.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.outlookAutoComplete.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.outlookAutoComplete.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.outlookAutoComplete.acknowledgeQuery",
    },
    "zscaler": {
        actionId: "reset_zscaler_connection",
        primaryBtn: "chatBot.nexthinkIntegration.restartZscalar.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.restartZscalar.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.restartZscalar.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.restartZscalar.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.restartZscalar.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.restartZscalar.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.restartZscalar.acknowledgeQuery",
    },
    "onedrive": {
        actionId: "repair_onedrive_windows",
        primaryBtn: "chatBot.nexthinkIntegration.onedrive.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.onedrive.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.onedrive.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.onedrive.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.onedrive.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.onedrive.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.onedrive.acknowledgeQuery",
    }, 
    "smartcard":{
        actionId: "#remove_microsoft_virtual_smart_cards",
        primaryBtn: "chatBot.nexthinkIntegration.smartcard.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.smartcard.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.smartcard.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.smartcard.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.smartcard.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.smartcard.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.smartcard.acknowledgeQuery",
    },
    "teamviewer-reset": {
        actionId: "#team_viewer_restart_service",
        primaryBtn: "chatBot.nexthinkIntegration.teamViewerReset.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.teamViewerReset.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.teamViewerReset.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.teamViewerReset.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.teamViewerReset.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.teamViewerReset.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.teamViewerReset.acknowledgeQuery",
    },
    "zoom-uninstall": {
        actionId: "#zoom_full_uninstallation",
        primaryBtn: "chatBot.nexthinkIntegration.zoomUninstall.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.zoomUninstall.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.zoomUninstall.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.zoomUninstall.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.zoomUninstall.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.zoomUninstall.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.zoomUninstall.acknowledgeQuery",
    },
    "webex-uninstall": {
        actionId: "#cisco_webex_full_uninstallation",
        primaryBtn: "chatBot.nexthinkIntegration.webexUninstall.primaryBtn",
        secondaryBtn: "chatBot.nexthinkIntegration.webexUninstall.secondaryBtn",
        successMsg: "chatBot.nexthinkIntegration.webexUninstall.successMsg",
        taskProgressMsg: "chatBot.nexthinkIntegration.webexUninstall.progressMsg",
        failureMsg: "chatBot.nexthinkIntegration.webexUninstall.failureMsg",
        disclaimer: "chatBot.nexthinkIntegration.webexUninstall.disclaimer",
        acknowledgeQuery: "chatBot.nexthinkIntegration.webexUninstall.acknowledgeQuery",
    }
};

export const taskStatus = {
    "#disk_cleanup_deep": {
        success: "chatBot.nexthinkIntegration.diskClean.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.diskClean.failureMsg",
        expired: "chatBot.nexthinkIntegration.diskClean.failureMsg",
        progress: "chatBot.nexthinkIntegration.diskClean.progressMsg",
    },
    "#disk_cleanup_light": {
        success: "chatBot.nexthinkIntegration.diskClean.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.diskClean.failureMsg",
        expired: "chatBot.nexthinkIntegration.diskClean.failureMsg",
        progress: "chatBot.nexthinkIntegration.diskClean.progressMsg",
    },
    "#clear_chrome_cache": {
        success: "chatBot.nexthinkIntegration.chromeCache.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.chromeCache.failureMsg",
        expired: "chatBot.nexthinkIntegration.chromeCache.failureMsg",
        progress: "chatBot.nexthinkIntegration.chromeCache.progressMsg",
    },
    "#clear_microsoft_edge_settings_gsd": {
        success: "chatBot.nexthinkIntegration.edgeCache.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.edgeCache.failureMsg",
        expired: "chatBot.nexthinkIntegration.edgeCache.failureMsg",
        progress: "chatBot.nexthinkIntegration.edgeCache.progressMsg",
    },
    "#repair_empower_addin": {
        success: "chatBot.nexthinkIntegration.empowerApp.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.empowerApp.failureMsg",
        expired: "chatBot.nexthinkIntegration.empowerApp.failureMsg",
        progress: "chatBot.nexthinkIntegration.empowerApp.progressMsg",
    },
    "#clear_microsoft_teams_work_or_school_cache_no_campaign": {
        success: "chatBot.nexthinkIntegration.teamsCache.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.teamsCache.failureMsg",
        expired: "chatBot.nexthinkIntegration.teamsCache.failureMsg",
        progress: "chatBot.nexthinkIntegration.teamsCache.progressMsg",
    },
    "#repair_teams_application_with_live_notification": {
        success: "chatBot.nexthinkIntegration.teamsReinstall.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.teamsReinstall.failureMsg",
        expired: "chatBot.nexthinkIntegration.teamsReinstall.failureMsg",
        progress: "chatBot.nexthinkIntegration.teamsReinstall.progressMsg",
    },
    "repair_outlook_ost_problem_windows": {
        success: "chatBot.nexthinkIntegration.outlookOst.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.outlookOst.failureMsg",
        expired: "chatBot.nexthinkIntegration.outlookOst.failureMsg",
        progress: "chatBot.nexthinkIntegration.outlookOst.progressMsg"
    },
    "repair_office_365_windows": {
        success: "chatBot.nexthinkIntegration.repairOfficeApps.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.repairOfficeApps.failureMsg",
        expired: "chatBot.nexthinkIntegration.repairOfficeApps.failureMsg",
        progress: "chatBot.nexthinkIntegration.repairOfficeApps.progressMsg"
    },
    "#trigger_intune_sync": {
        success: "chatBot.nexthinkIntegration.intuneSync.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.intuneSync.failureMsg",
        expired: "chatBot.nexthinkIntegration.intuneSync.failureMsg",
        progress: "chatBot.nexthinkIntegration.intuneSync.progressMsg"
    },
    "#repair_microsoft_teams_addin": {
        success: "chatBot.nexthinkIntegration.teamsAddin.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.teamsAddin.failureMsg",
        expired: "chatBot.nexthinkIntegration.teamsAddin.failureMsg",
        progress: "chatBot.nexthinkIntegration.teamsAddin.progressMsg"
    },
    "invoke_windows_update_windows": {
        success: "chatBot.nexthinkIntegration.windowsUpdate.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.windowsUpdate.failureMsg",
        expired: "chatBot.nexthinkIntegration.windowsUpdate.failureMsg",
        progress: "chatBot.nexthinkIntegration.windowsUpdate.progressMsg"
    },
    "#set_timezone_auto_update": {
        success: "chatBot.nexthinkIntegration.timezone.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.timezone.failureMsg",
        expired: "chatBot.nexthinkIntegration.timezone.failureMsg",
        progress: "chatBot.nexthinkIntegration.timezone.progressMsg"
    },
    "clear_outlook_autocomplete_cache_windows": {
        success: "chatBot.nexthinkIntegration.outlookAutoComplete.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.outlookAutoComplete.failureMsg",
        expired: "chatBot.nexthinkIntegration.outlookAutoComplete.failureMsg",
        progress: "chatBot.nexthinkIntegration.outlookAutoComplete.progressMsg"
    },
    "reset_zscaler_connection": {
        success: "chatBot.nexthinkIntegration.restartZscalar.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.restartZscalar.failureMsg",
        expired: "chatBot.nexthinkIntegration.restartZscalar.failureMsg",
        progress: "chatBot.nexthinkIntegration.restartZscalar.progressMsg"
    },
    "repair_onedrive_windows": {
        success: "chatBot.nexthinkIntegration.onedrive.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.onedrive.failureMsg",
        expired: "chatBot.nexthinkIntegration.onedrive.failureMsg",
        progress: "chatBot.nexthinkIntegration.onedrive.progressMsg"
    },
    "#remove_microsoft_virtual_smart_cards": {
        success: "chatBot.nexthinkIntegration.smartcard.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.smartcard.failureMsg",
        expired: "chatBot.nexthinkIntegration.smartcard.failureMsg",
        progress: "chatBot.nexthinkIntegration.smartcard.progressMsg"
    },
    "#team_viewer_restart_service": {
        success: "chatBot.nexthinkIntegration.teamViewerReset.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.teamViewerReset.failureMsg",
        expired: "chatBot.nexthinkIntegration.teamViewerReset.failureMsg",
        progress: "chatBot.nexthinkIntegration.teamViewerReset.progressMsg"
    },
    "#zoom_full_uninstallation": {
        success: "chatBot.nexthinkIntegration.zoomUninstall.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.zoomUninstall.failureMsg",
        expired: "chatBot.nexthinkIntegration.zoomUninstall.failureMsg",
        progress: "chatBot.nexthinkIntegration.zoomUninstall.progressMsg"
    },
    "#cisco_webex_full_uninstallation": {
        success: "chatBot.nexthinkIntegration.webexUninstall.successMsgOnList",
        failure: "chatBot.nexthinkIntegration.webexUninstall.failureMsg",
        expired: "chatBot.nexthinkIntegration.webexUninstall.failureMsg",
        progress: "chatBot.nexthinkIntegration.webexUninstall.progressMsg"
    }
};
